import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render SUTD section on Partners page
 */
const SUTDSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 leading-[1.4]"
      data-testid="sutd-section-component"
    >
      <AccordionV2
        testId="sutd-accordion"
        className="rounded-bl-lg rounded-br-lg border border-t-0 border-gray-175 bg-gray-150 py-4"
        headerChildren={<EventsAwardsAccordionHeader title="SUTD" />}
        arrowClassName="border-none h-auto w-auto -rotate-90 mr-6"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 pt-4">
          <p>
            Fifteen years ago, the Singapore University of Technology and Design
            (SUTD) became one of the first universities in the world to
            incorporate the art and science of design and technology into a
            holistic interdisciplinary education and research experience. Since
            then, SUTD undergraduate and postgraduate students have thrived in a
            design-steeped environment, constantly encouraged to think
            creatively and innovatively to find human-centric solutions for
            real-world problems.
          </p>

          <p>
            On 11 March 2024, SUTD unveiled a new growth strategy called SUTD
            Leap. By redesigning higher education with an even greater focus on
            design, AI and technology, SUTD Leap aims to propel the university
            to the forefront of the design x tech space whilst nurturing the
            next generation of design x tech innovators and innovator leaders.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default SUTDSection;
